import { useTheme } from '@mui/material';
import { TableV1 } from '../../../components/Table/TableV1';
import {
  ColumnFiltersState,
  SortingState,
  getCoreRowModel,
  getFacetedUniqueValues,
  getFilteredRowModel,
  getSortedRowModel,
  useReactTable,
} from '@tanstack/react-table';
import { useState } from 'react';
import { useAllOpenTSTableColumns } from '../hooks/useAllOpenTSTableColumns';
import { useAllOpenLogsMapped } from '../hooks/useAllOPLogsMapped';
import { User } from '../../../types';
import { TableSkeletonLoader } from '../../../components/SkeletonLoader/Table.SkeletonLoader';
import { OpenTimesheetsFilterSection } from './OpenTimesheetsFilterSection';

interface AllOpenTimesheetsTableProps {
  operatingPartners: User[];
  timesheetsLoading: boolean;
}

export const OpenTimesheetApprovalsTable = ({
  operatingPartners,
  timesheetsLoading,
}: AllOpenTimesheetsTableProps) => {
  const { colors } = useTheme();

  const [sorting, setSorting] = useState<SortingState>([]);
  const [columnFilters, setColumnFilters] = useState<ColumnFiltersState>([]);

  const allOPLogs = useAllOpenLogsMapped(operatingPartners);
  const columns = useAllOpenTSTableColumns();

  const table = useReactTable({
    data: allOPLogs ?? [],
    columns,
    state: {
      sorting,
      columnFilters,
    },
    enableRowSelection: true,
    enableSorting: true,
    onSortingChange: setSorting,
    onColumnFiltersChange: setColumnFilters,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getFacetedUniqueValues: getFacetedUniqueValues(),
  });

  return (
    <>
      {timesheetsLoading ? (
        <TableSkeletonLoader />
      ) : (
        <>
          <OpenTimesheetsFilterSection operatingPartners={operatingPartners} table={table} />
          <TableV1
            table={table}
            height='auto'
            isLastColumnSticky={false}
            wrapperStyle={{
              maxHeight: 'calc(100vh - 320px)',
              overflowX: 'scroll',
              border: `1px solid ${colors.border.default}`,
            }}
          />
        </>
      )}
    </>
  );
};
